import { render, staticRenderFns } from "./myClientDebtWarning.vue?vue&type=template&id=45b1bcf4&functional=true&"
import script from "./myClientDebtWarning.vue?vue&type=script&lang=js&"
export * from "./myClientDebtWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports